module.exports = __webpack_public_path__ + "img/mobile_t29.59389397.png";